<template >
  <div>
    article default page:

 
    <div>article:</div>
    {{ article.id }}
    {{ article.title }}
    {{ article.content }}

    <div>category:</div>
    {{article.category!.id}}
    {{article.category!.name}}
    {{article.category!.url}}
    
  </div>
</template>

<script setup lang="ts" name="ArticleDefault">
  import {ref} from 'vue'
import type { Article, Category } from '~/types';
  const props = defineProps<{
    article: Article  
  }>()

</script>

<style scoped lang='scss'>

</style>
